import React, { useState } from 'react'
import { useAtom, useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { Box, Button, MenuItem, Select } from '@mui/material'
import {
  gDriveFilesForSelectedCourseAtom,
  selectedCourseAtom,
  sortedS3Files,
} from './atoms'
import { useRetrieveGDriveContentForCourse } from './hooks'
import { SelectedCourse } from './SelectedCourse'

export function IngestionFromS3() {
  return (
    <Box padding="5px">
      <Box>S3 OSE Courses</Box>
      <CourseSelection />
      <SelectedCourse />
    </Box>
  )
}

function CourseSelection() {
  const files = useAtomValue(sortedS3Files)
  const [selected, setSelected] = useAtom(selectedCourseAtom)

  return (
    <Box>
      <Select
        displayEmpty={true}
        value={selected}
        onChange={(e) => setSelected(e.target.value as string)}
        renderValue={(value) => (value ? String(value) : 'Select Course')}
      >
        {Object.keys(files).map((fileKey) => {
          return (
            <MenuItem key={fileKey} value={fileKey}>
              {fileKey}
            </MenuItem>
          )
        })}
      </Select>
    </Box>
  )
}

export function GDriveRetrieveButton() {
  const [retrieving, setRetrieving] = useState(false)
  const gDriveRetrieve = useRetrieveGDriveContentForCourse()
  const files = useAtomValue(gDriveFilesForSelectedCourseAtom)

  const fileCount = files?.reduce<number>(
    (acc, { fileMap }) => acc + Object.keys(fileMap ?? {}).length,
    0,
  )

  const doRetrieve = async () => {
    setRetrieving(true)
    await gDriveRetrieve()
    setRetrieving(false)
  }

  return (
    <Button disabled={retrieving || !fileCount} onClick={doRetrieve}>
      {retrieving ? 'Retrieving...' : 'Retrieve Course Files'}
    </Button>
  )
}
